<template>
  <div class="qr-card">
    <div class="link-content">
      <div class="blue_bg"></div>
      <div class="qr-content">
        <qriously
          class="qrcode"
          :value="$store.state.appConfig.h5_domain ? $store.state.appConfig.h5_domain + 'download' : ''"
          :size="83"
          style="width: 100%"
        />
        <div class="name">猎鹰APP</div>
        <div class="s-name">扫二维码下载</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return { baidu: "wwww.baidu.com" };
  },
  computed: {
    // ...mapState(['appConfig'])
  },
  mounted() {
    //   console.log(this.$store.state.appConfig)
    // const { dl_android } = this.appConfig
    // this.android_address = dl_android
  },
  methods: {
    // showQrCard() {
    //   this.$emit("showQrCard");
    // },
    // closeQrCard() {
    //   this.$emit("closeQrCard");
    // },
  },
};
</script>

<style lang="stylus" scoped>
.qr-card {
  width: 160px;
  box-shadow: 2px 2px 3px 0px rgba(142, 142, 142, 0.2);
  border-radius: 3px;
  position: absolute;
  top: 58px;
  right: 80px;
  z-index: 999;
  &:before {
    content: '';
    width: 0px;
    height: 0px;
    position: absolute;
    top: -16px;
    right: 58px;
    transform: translateX(-50%);
    border: solid 8px transparent;
    border-bottom: solid 8px #26D99D ;
  }
  &:after {
    content: '';
    width: 0px;
    height: 0px;
    position: absolute;
    top: -11px;
    right: 58px;
    transform: translateX(-50%);
    border: solid 8px transparent;
    border-bottom: solid 8px #ffffff;
  }
  .blue_bg {
    width: 100%;
    background: #26D99D;
    height: 3px;
    position: relative;
  }
  .link-content {
    background-color: #ffffff;
    width: 100%;
    border-radius: 8px;
    overflow : hidden;
    // padding: 13px 19px 0 19px;
  }
  .qr-content{
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items :center;
    padding : 20px;
    .qrcode{
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .name{
      font-size: 15px;
      color: #333333;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
      padding: 10px;
    }
    .s-name{
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      padding:5px;
      padding-bottom : 0px;
    }
  }
}
</style>
